module.exports = __webpack_public_path__ + "static/img/contact_bg.c36d695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact_bg.png
// module id = 339b
// module chunks = 0